import RewardInfo from './RewardInfo';

export default RewardInfo;
